<button
  [ngClass]="['btn', computedVariant, sizeClass]"
  [style.width]="width"
  [disabled]="loading || disabled"
  (click)="onClick()"
>
  @if (loading) {
    <span class="spinner-border spinner-border-sm me-2"></span>
  }
  @if (iconClass && !loading && label.length > 0) {
    <i [class]="iconClass + (label ? ' me-2' : '')" style=""></i>
  }
  @if (iconClass && !loading && label.length <= 0) {
    <i [class]="iconClass" style="display: inline-flex; justify-content: center; margin-left: 5px; color: #19226d"></i>
  }
  {{ label }}
</button>
